import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import FormElementWrapper from '../components/FormElementWrapper';
import InlineEdit from '../components/InlineEdit';
import { Sizes } from '../form-edits-components/Size';

const mapSizeToFontSize = {
  [Sizes.Small]: 24,
  [Sizes.Medium]: 30,
  [Sizes.Big]: 36,
};

const Title = props => {
  const { text, size } = props.data;
  const { readOnly } = props;
  const [isEditing, setIsEditing] = useState(false);
  const { setFieldValue, values } = useFormikContext();
  const index = values?.data?.findIndex(({ id }) => id === props.data.id);

  const handleChange = e => {
    const { name, value } = e.target;
    setFieldValue(`data[${index}].${name}`, value);
  };

  return (
    <FormElementWrapper {...props} onClick={!readOnly ? () => setIsEditing(true) : undefined}>
      <div
        className="font-semibold"
        style={{
          fontSize: mapSizeToFontSize[size],
        }}
      >
        <InlineEdit
          value={text}
          onChange={handleChange}
          fieldName="text"
          isEditing={isEditing}
          onSetIsEditing={setIsEditing}
          readOnly={readOnly}
        />
      </div>
    </FormElementWrapper>
  );
};

export default Title;
